<div *ngIf="!loading else loadingForums">
  <section class="Forum__Header">
    <div class="container container-forum">
      <div class="row">
        <div class="Forum__Header--text col-12">
          <h1>{{lang == 'es' ? (forum.title || forum.title_en) : (forum.title_en || forum.title) }}</h1>
          <div class="div Forum__Header--author">
            <img [src]="forum.user?.avatar" alt="Author" width="20" height="20" />
            <p class="Forum__Post--authorName">{{(forum.user?.name ? forum.user?.name : forum.user?.initials)}}
              <ng-container [ngSwitch]="forum.user?.bhavani_badge">
                <span *ngSwitchCase="'BHAVANI_TEAM'" class="bhavani_badge" i18n>(Equipo BHAVANI)</span>
                <span *ngSwitchCase="'BHAVANI_COACH'" class="bhavani_badge" i18n>(Coach BHAVANI)</span>
              </ng-container>
            </p>
          </div>
          <div class="div Forum__Header--date">
            <img src="assets/images/clock-icon.svg" width="20" alt="">
            <p>{{forum.created_at | date}}</p>
          </div>
          <div>
            <a *ngIf="forum.can_manage" [routerLink]="['/platform/forum', forum.slug, 'edit', '.']" class="btn btn-warning" i18n>Editar entrada</a>
            <button *ngIf="forum.can_manage" class="btn btn-danger" (click)="destroyResource()" i18n>Eliminar
              publicación</button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="Forum__Body">
    <div class="container container-forum">
      <div class="row">
        <div [innerHTML]="lang == 'es' ? (forum.content || forum.content_en) : (forum.content_en || forum.content) ">
        </div>
      </div>
      <div class="row">
        <button class="btn Forum__Body--like" [ngClass]="{'active': forum.liked_by_current_user}" (click)="toggleLike()">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.5 7.52882L2.12268 7.47499C2.09384 7.14153 1.80744 6.88997 1.47306 6.9044C1.13867 6.91883 0.875 7.19412 0.875 7.52882H1.5ZM15.8634 9.04815L15.2755 12.4479L16.5072 12.661L17.0952 9.26115L15.8634 9.04815ZM10.0375 16.7087H6.16363V17.9587H10.0375V16.7087ZM5.40415 16.0107L4.72735 8.18349L3.482 8.29115L4.1588 16.1184L5.40415 16.0107ZM15.2755 12.4479C14.8532 14.8901 12.6511 16.7087 10.0375 16.7087V17.9587C13.226 17.9587 15.9757 15.7345 16.5072 12.661L15.2755 12.4479ZM10.0457 3.25045L9.49342 6.62092L10.727 6.82303L11.2793 3.45256L10.0457 3.25045ZM4.98978 7.53832L6.18872 6.5052L5.37274 5.55827L4.17379 6.59143L4.98978 7.53832ZM8.37 3.1437L8.76642 1.6155L7.5565 1.30163L7.16007 2.82984L8.37 3.1437ZM9.36517 1.31566L9.486 1.35447L9.86833 0.16438L9.7475 0.125571L9.36517 1.31566ZM7.76958 4.68031C8.0295 4.19364 8.23142 3.67815 8.37 3.1437L7.16007 2.82984C7.04644 3.26788 6.88083 3.6911 6.66702 4.09135L7.76958 4.68031ZM9.486 1.35447C9.74133 1.4365 9.92267 1.63373 9.98225 1.86352L11.1923 1.54966C11.021 0.889646 10.5158 0.372388 9.86833 0.16438L9.486 1.35447ZM8.76642 1.6155C8.79567 1.50299 8.87692 1.3996 8.99983 1.34035L8.45717 0.21428C8.01383 0.427896 7.68083 0.822213 7.5565 1.30163L8.76642 1.6155ZM8.99983 1.34035C9.11208 1.28625 9.24425 1.27683 9.36517 1.31566L9.7475 0.125571C9.32275 -0.0108871 8.85933 0.0204879 8.45717 0.21428L8.99983 1.34035ZM10.7948 8.15382H15.1123V6.90382H10.7948V8.15382ZM2.93234 16.8387L2.12268 7.47499L0.877325 7.58265L1.68699 16.9464L2.93234 16.8387ZM2.125 16.9276V7.52882H0.875V16.9276H2.125ZM1.68699 16.9464C1.676 16.8193 1.77622 16.7087 1.90559 16.7087V17.9587C2.51057 17.9587 2.98435 17.4402 2.93234 16.8387L1.68699 16.9464ZM11.2793 3.45256C11.383 2.81912 11.3534 2.17097 11.1923 1.54966L9.98225 1.86352C10.0998 2.31635 10.1213 2.78875 10.0457 3.25045L11.2793 3.45256ZM6.16363 16.7087C5.7687 16.7087 5.43834 16.4062 5.40415 16.0107L4.1588 16.1184C4.24877 17.1588 5.11892 17.9587 6.16363 17.9587V16.7087ZM6.18872 6.5052C6.75527 6.01699 7.366 5.43588 7.76958 4.68031L6.66702 4.09135C6.37837 4.63171 5.91875 5.08776 5.37274 5.55827L6.18872 6.5052ZM17.0952 9.26115C17.3079 8.03074 16.3618 6.90382 15.1123 6.90382V8.15382C15.5845 8.15382 15.9443 8.58024 15.8634 9.04815L17.0952 9.26115ZM1.90559 16.7087C2.02743 16.7087 2.125 16.8073 2.125 16.9276H0.875C0.875 17.4964 1.33574 17.9587 1.90559 17.9587V16.7087ZM9.49342 6.62092C9.362 7.42333 9.9805 8.15382 10.7948 8.15382V6.90382C10.7532 6.90382 10.7199 6.86616 10.727 6.82303L9.49342 6.62092ZM4.72735 8.18349C4.70617 7.93849 4.80396 7.69849 4.98978 7.53832L4.17379 6.59143C3.68352 7.01391 3.42624 7.6464 3.482 8.29115L4.72735 8.18349Z"
              fill="#1C274C" />
          </svg>
          <p><span i18n>Me gusta</span> ({{forum.likes_count || 0}})</p>
        </button>
      </div>
    </div>
  </section>
  <section class="Forum__Comments" id="comments">
    <div class="container container-forum">
      <hr />
      <p class="title" i18n>Comentarios</p>
      <div class="Forum__Comments-list">
        <div *ngFor="let comment of forum?.comments">
          <div class="Forum__Comments--comment col-12">
            <div class="Forum__Comments--comment--author">
              <img [src]="comment.user?.avatar" class="avatar" alt="Author" width="20" height="20" />
            </div>
            <div class="Forum__Comments--comment--body">
              <div class="Forum__Comments--comment header">
                <p class="authorName">{{(comment.user?.name ? comment.user?.name :
                  comment.user?.initials)}}
                  <ng-container [ngSwitch]="comment.user?.bhavani_badge">
                    <span *ngSwitchCase="'BHAVANI_TEAM'" class="bhavani_badge" i18n>(Equipo BHAVANI)</span>
                    <span *ngSwitchCase="'BHAVANI_COACH'" class="bhavani_badge" i18n>(Coach BHAVANI)</span>
                  </ng-container>
                </p>
                <p class="commentDate">{{comment.created_at | date}}</p>
              </div>
              <div class="Forum__Comments--comment content">
                <p [innerHTML]="comment.text"></p>
              </div>
              <div>
                <button *ngIf="comment.can_delete" class="btn btn-danger" i18n
                  (click)="destroyComment(comment.id)">Eliminar comentario</button>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="this.formMainComment" (submit)="saveMainComment()">
        <div class="form-group">
          <textarea formControlName="text" class="form-control" id="comment" rows="3"
            placeholder="Escribe tu comentario" i18n-placeholder></textarea>
        </div>
        <button type="submit" class="bh-btn btn-primary" i18n>Enviar</button>
      </form>
    </div>
  </section>
  <section class="Forum__Disclaimer">
    <div class="container container-forum">
      <p><strong i18n>Nota:</strong></p>
      <p i18n>El contenido de esta entrada y sus comentarios es responsabilidad exclusiva de las personas que los
        redactan y no refleja necesariamente las opiniones, creencias o políticas de Bhavani. Bhavani no asume ninguna
        responsabilidad por la veracidad o precisión de la información proporcionada en esta entrada y sus comentarios.
        Los lectores deben tomar el contenido aquí compartido bajo su propia discreción y riesgo.</p>
    </div>
  </section>
</div>
<ng-template #loadingForums>
  <loading-dots-modal-component></loading-dots-modal-component>
</ng-template>